const DEFAULT_PORTAL_URL = 'https://data.orderlymeds.com';

export function isPortalHost(hostname = window.location.hostname): boolean {
	return hostname === 'data.orderlymeds.com' || hostname.endsWith('.data.orderlymeds.com');
}

export function portalUrl(): string {
	return (import.meta.env.VITE_PORTAL_URL as string | undefined) ?? DEFAULT_PORTAL_URL;
}

export function restartPortalLogin(): void {
	window.location.assign(window.location.href);
}
